@if (task() && response) {
  <div class="responseDetail">
    <h3 class="responseHeader">{{ task().name }}</h3>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Entity ID</label>
      </span>
      <span class="inputField">
        <label>{{ task().entityId }};{{ task().entityRevision }}</label>
      </span>
    </div>
    <div>
      <span class="spacerLabel"></span>
      <input class="radioInput" type="radio" id="taxableResponse" value="T" name="outcome"
        [(ngModel)]="response.additionalData"/>
      <label class="radioLabel" for="taxableResponse">Taxable - Project is taxable</label>
    </div>
    <div>
      <span class="spacerLabel"></span>
      <input class="radioInput" type="radio" id="notTaxableResponse" value="N" name="outcome"
        [(ngModel)]="response.additionalData"/>
      <label class="radioLabel" for="notTaxableResponse">Non-Taxable - Project is not taxable</label>
    </div>
    <div>
      <span class="spacerLabel"></span>
      <input class="radioInput" type="radio" id="unknownResponse" value="U" name="outcome"
        [(ngModel)]="response.additionalData"/>
      <label class="radioLabel" for="unknownResponse">Unknown - Project's tax status is Unknown</label>
    </div>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Comments</label>
      </span>
      <span>
        <textarea class="unresizable inputField" rows="3" cols="40" [(ngModel)]="response.comments"></textarea>
      </span>
    </div>
    <div class="toolbar">
      <span class="spacer"></span>
      <span>
        <button class="primary-button" matButton="elevated" [disabled]="!response || !response.additionalData || isBusy()"
          (click)="saveResponse()">
          <span>
            <mat-icon class="size-16">done</mat-icon>
            <label>Complete Task</label>
          </span>
        </button>
      </span>
    </div>
  </div>
}
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}

